export default {"src":"/_next/static/media/TOST.92215842.svg","height":18,"width":18};